export default {
  pinnable: false,
  customizeTranslate: true,
};
